export const breakpoints = {
  mobileLg: 576,
  tablet: 768,
  desktop: 992,
  desktopLg: 1200,
  desktopXl: 1400,
  desktopXxl: 1700
};

export const device = {
  mobileLg: `(min-width: ${breakpoints.mobileLg}px)`,
  tablet: `(min-width: ${breakpoints.tablet}px)`,
  desktop: `(min-width: ${breakpoints.desktop}px)`,
  desktopLg: `(min-width: ${breakpoints.desktopLg}px)`,
  desktopXl: `(min-width: ${breakpoints.desktopXl}px)`,
  desktopXxl: `(min-width: ${breakpoints.desktopXxl}px)`,
  mobileOnly: `(max-width: ${breakpoints.tablet - 1}px)`,
  deviceOnly: `(max-width: ${breakpoints.desktop - 1}px)`
};

export const shadows = {
  cardShadow: 'box-shadow: 0px 16px 80px rgba(91, 110, 127, 0.25);',
  inputShadow: 'box-shadow: 0px 10px 20px rgba(91, 110, 127, 0.15);'
};
